export enum EChatAssistant {
  getAssistantResponse = 'chatAssistant',
}
